import { memo, useEffect } from "react";

import { setDebugMode } from "../model/actions";
import useAppDispatch from "../utils/hooks/useAppDispatch";
import useAppSelector from "../utils/hooks/useAppSelector";

// Active debug on ctrl+d
function DebugModeListener() {
  const dispatch = useAppDispatch();
  const debug = useAppSelector((state) => state.debug);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.which === 68 /* d */) {
        dispatch(setDebugMode(!debug));
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [debug, dispatch]);

  return null;
}

export default memo(DebugModeListener);
